import { Component, Input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { selectCopyrightParams } from '@ispm/widgets/store/selectors';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { CopyrightPayload } from '@ispm/widgets/components/copyright.component/interfaces/copyright-payload.interface';
import { IdynamicFormItem } from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';

@Component({
  selector: 'ispm-copyright',
  templateUrl: './copyright.component.html',
  styleUrls: ['./copyright.component.scss']
})
export class CopyrightComponent implements OnInit, IWidgetItem<CopyrightPayload> {


  widgetConfig: IdynamicFormItem<CopyrightPayload>;
  widgetData: any;
  widgetFormInstance: FormGroup;
  widgetUpdateValueCallback: (value) => void;

  @Input()
  useConfiguration: boolean = false;
  @Input()
  cssClass: string;
  @Input()
  prefix: string;
  @Input()
  iconPath?: string;
  @Input()
  fontIcon?: string;
  @Input()
  suffix: string;
  @Input()
  externalLink: string;

  constructor(private store$: Store<any>) { }

  ngOnInit() {
    if (this.useConfiguration) {
      (this.widgetConfig && this.widgetConfig.widgetPayload
        ? Observable.of(this.widgetConfig.widgetPayload)
        : this.store$.pipe(
          select(selectCopyrightParams),
          take(1))
      ).subscribe(params => {
        Object.assign(this, params);
      });
    }
  }

  openLink() {
    if (this.externalLink) {
      window.open(this.externalLink, '_blank');
    }
  }
}
